import axios from '@/plugins/axios'
import alert from '@/plugins/alert'
import api, { Staff } from '../../plugins/api'

const USER_API = '/users/'
const STAFF_COUNT_API = '/staff/count'
const STAFF_API = '/staff/'
const DESTROY_API = '/upload/files/'
const UPLOAD_API = '/upload/'

export default {
  namespaced: true,
  state: {
    staffs: [],
    staff: {},
    count: 0,
    pageText: '',
    itemsPerPage: 10,
    staffSearchParams: {},
    totalItems: 0,
    loading: false
  },
  actions: {
    async searchStaffs({ commit, state, dispatch }, query) {
      const staffSearchParams = {
        _limit: state.itemsPerPage,
        ...query
      }

      commit('changeState', { staffSearchParams })
      await dispatch('requestPageSettings', {})
    },
    async requestPageSettings({ state, commit, dispatch }, { page, itemsPerPage }) {
      state.loading = true
      commit('changeState', { loading: true })
      if (!page) page = 1
      if (!itemsPerPage) itemsPerPage = state.itemsPerPage
      if (state.staffSearchParams) {
        const staffSearchParams = {
          ...state.staffSearchParams,
          _start: (page - 1) * itemsPerPage,
          _limit: itemsPerPage,
          _sort: 'nameToNumber:ASC'
        }
        const [totalItems, staffs] = await Promise.all([
          Staff.count(staffSearchParams),
          Staff.search(staffSearchParams)
        ])

        if (totalItems > (page - 1) * itemsPerPage || page === 1) {
          commit('changeState', {
            staffs,
            totalItems,
            itemsPerPage,
            staffSearchParams
          })

          const pageStart = (page - 1) * itemsPerPage + 1
          let pageStop = page * itemsPerPage
          pageStop = pageStop > totalItems || pageStop === -1 ? totalItems : pageStop
          const pageText = `${pageStart}-${pageStop} trên ${totalItems}`
          commit('changeState', { pageText })
        } else {
          // var pages = rangeRight(1, page)
          // for (let index = 0; index < pages; index++) {
          //   const selectedPage = pages[index]
          //   if (totalItems > (selectedPage - 1) * itemsPerPage) {
          //     dispatch('requestPageSettings', {})
          //     break
          //   }
          // }
        }
      }

      commit('changeState', { loading: false })
    },

    fetchStaffsCount({ commit }, filters = []) {
      const params = { _limit: -1 }
      filters.forEach(f => {
        if (f.value === 0 || f.value) {
          params[f.key + (f.type ? '_' + f.type : '')] = f.value
        }
      })
      return axios
        .get(STAFF_COUNT_API, { params })
        .then(count => {
          commit('setCount', count || 0)
        })
        .catch(e => alert.error(e))
    },
    fetchStaffs({ commit }, query = '') {
      return axios
        .get(STAFF_API + query)
        .then(staffs => commit('setStaffs', staffs))
        .catch(e => alert.error(e))
    },
    fetchStaffsByTitle({ dispatch }, keyword) {
      if (!keyword) return
      return dispatch('fetchStaffs', {
        params: { title_contains: keyword },
        hideLoading: true
      })
    },
    fetchStaff({ commit }, staffId) {
      return axios
        .get(STAFF_API + staffId)
        .then(staff => commit('setStaff', staff))
        .catch(e => alert.error(e))
    },
    uploadAvatar({ commit }, formData) {
      return axios
        .post(UPLOAD_API, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          commit('setAvatar', response[0])
          return response[0]
          // alert.success('Tải ảnh thành công!')
        })
        .catch(e => alert.error('Tải ảnh thất bại'))
    },
    destroyAvatar({ commit }, id) {
      return axios
        .delete(DESTROY_API + id)
        .then(staff => {
          commit('setAvatar', null)
          return null
        })
        .catch(e => alert.error(e))
    },
    async createStaff({ commit }, data) {
      try {
        const user = await api.User.create({ ...data, type: 'staff' })
        if (user) {
          data.user = user.id
          data.code = user.username
          const staff = await api.Staff.create({ ...data })
          commit('setStaff', staff)
          commit('receiveStaff', staff)
          alert.success('Tạo mới thành công')
          return staff
        } else {
          alert.error('Tạo Thất Bại!')
        }
      } catch (error) {
        console.error(error)
        alert.error('Tạo Thất Bại!')
      }
    },
    updateStaff({ commit, state }, { id, ...staff }) {
      return axios
        .put(STAFF_API + id, staff)
        .then(staff => {
          commit('setStaff', staff)
          commit('receiveStaff', staff)
          alert.success('Cập nhật thành công')
        })
        .catch(e => alert.error('Cập nhật thất bại'))
    },
    async updateStaffs({ dispatch }, staffs) {
      for (let item of staffs) {
        await dispatch('updateStaff', item)
      }
    },
    async removeStaff({ commit }, staff) {
      if (staff.user) {
        await axios.delete(USER_API + staff.user).catch(e => alert.error(e))
      }
      await axios
        .delete(STAFF_API + staff.id)
        .then(staff => {
          commit('removeStaff', staff.id)
          alert.success('Xóa thành công')
        })
        .catch(e => alert.error(e))
    },
    async removeStaffs({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeStaff', item)
      }
    },
    setStaff({ commit }, staff) {
      commit('setStaff', staff)
    },
    setStaffs({ commit }, staffs) {
      commit('setStaffs', staffs)
    },
    async updatePassword(_, params) {
      await Staff.updatePasswordStaff(params)
    }
  },
  mutations: {
    setAvatar(state, avatar) {
      state.staff = {
        ...state.staff,
        avatar: avatar
      }
      state.avatar = avatar
    },
    setStaffs(state, staffs) {
      state.staffs = staffs
    },
    setStaff(state, staff) {
      state.staff = staff
    },
    setCount(state, count) {
      state.count = count
    },
    receiveStaff(state, staff) {
      const i = state.staffs.findIndex(d => d.id === staff.id)
      if (i > -1) {
        state.staffs.splice(i, 1, staff)
      } else {
        state.staffs.unshift(staff)
      }
    },
    removeStaff(state, staffId) {
      const i = state.staffs.findIndex(({ id }) => id === staffId)
      if (i > -1) {
        state.staffs.splice(i, 1)
      }
    }
  },
  getters: {
    staffs: state => {
      return state.staffs
    },
    staff: state => {
      return state.staff || {}
    }
  }
}
